// Shared helper — render "[REC] Pitch 1 · Venue Name" from a booking or pitch object.
// Venue code (location ID) always leads when known; venue name follows; falls back to the bare pitch name.
export function pitchLabel(b) {
  if (!b) return "";
  const name = b.pitch_name || b.name || "";
  if (!name) return "";
  const code = b.venue_short_code || null;
  const venue = b.venue_name || b.venue?.name || null;
  const lead = code ? `[${code}] ${name}` : name;
  return venue ? `${lead} · ${venue}` : lead;
}
